<template>
  <span>
    <b-container fluid>
      <b-row class="table-header">
        <b-col cols="12" offset-lg="6" lg="6" offset-xl="9" xl="3">
          <b-form-group>
            <b-form-input
              ref="search"
              v-model="meta.search"
              :disabled="fetching"
              placeholder="Search by name"
              @input="searchChanged"/>
          </b-form-group>
        </b-col>
      </b-row>

      <no-data v-if="noData" message="No modules found..."/>

      <b-table
        v-if="data.length"
        ref="table"
        :hover="!fetching"
        :responsive="true"
        :fixed="true"
        :busy="fetching"
        :items="data"
        :fields="formFields"
        :per-page="Number(meta.per_page)"
        :sort-by="meta.order"
        :sort-desc="meta.desc"
        :no-local-sorting="true"
        class="client-table"
        @sort-changed="sortChanged"
        @row-clicked="rowClicked">

        <template slot="name" slot-scope="data">
          <row :module="data.item"/>
        </template>
      </b-table>

      <b-row>
        <b-col cols="12">
          <b-pagination
            v-if="data.length"
            :disabled="fetching"
            :value="Number(meta.current_page)"
            :total-rows="Number(meta.total)"
            :per-page="Number(meta.per_page)"
            @change="pageChanged"/>
        </b-col>
      </b-row>

    </b-container>
  </span>
</template>

<script>
import tableMixin from '../../mixins/client-table'
import row from './row'

export default {
  components: {
    row
  },
  mixins: [tableMixin],
  data () {
    return {
      namespace: 'modules',
      routeParamName: 'module',
      rowClickRoute: 'client-components',
      formFields: [
        { key: 'name', label: 'Name' }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/client/modules/table.vue